import {useState} from 'react'
import {graphql, useFragment} from 'react-relay'

import type {ProjectItemSection$key} from './__generated__/ProjectItemSection.graphql'
import {ProjectItemSectionView} from './ProjectItemSectionView'
import {ProjectItemSectionFieldList} from './ProjectItemSectionFieldList'

export type ProjectItemSectionProps = {
  projectItem: ProjectItemSection$key
  isOpen: boolean
  onIssueUpdate?: () => void
}

export function ProjectItemSection({projectItem, onIssueUpdate, isOpen = false}: ProjectItemSectionProps) {
  const [open, setOpen] = useState(isOpen)
  const data = useFragment(
    graphql`
      fragment ProjectItemSection on ProjectV2Item {
        id
        isArchived
        project {
          id
        }
        ...ProjectItemSectionView
      }
    `,
    projectItem,
  )

  return (
    <>
      <ProjectItemSectionView projectItem={data} open={open} setOpen={setOpen} />
      {open && (
        <ProjectItemSectionFieldList
          projectItemId={data.id}
          projectId={data.project.id}
          isArchived={data.isArchived}
          onIssueUpdate={onIssueUpdate}
        />
      )}
    </>
  )
}

try{ ProjectItemSection.displayName ||= 'ProjectItemSection' } catch {}